'use client';

import clsx from 'clsx';
import { PropsWithChildren, useEffect, useRef, useState } from 'react';
import anime from 'animejs';

interface StampProps {
  className?: string;
  enabled?: boolean;
  delay?: number;
  rotate?: number;
  text?: string;
  white?: boolean;
  purple?: boolean;
}

export default function Stamp({
  className,
  enabled = true,
  delay = 500,
  rotate = 0,
  text,
  white,
  purple,
  children,
}: PropsWithChildren<StampProps>) {
  const [isEnabled, setIsEnabled] = useState(enabled);
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const timoutRef = setTimeout(() => {
      setIsEnabled((value) => (!value ? enabled : value));
    }, delay);
    return () => clearTimeout(timoutRef);
  }, [enabled, delay]);
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const targets = ref.current;
    if (targets && isEnabled) {
      targets.style.opacity = '0';
      anime({
        targets,
        easing: 'spring(1, 100, 10, 0)',
        scale: 1,
        opacity: 1,
        delay,
      });
      return () => {
        anime.remove(targets);
      };
    }
  }, [isEnabled, ref, delay, rotate]);
  return (
    <span
      ref={ref}
      style={{
        display: 'inline-flex',
        opacity: 0,
        transformOrigin: 'left',
        willChange: 'opacity',
        transform: `rotate(${rotate}deg) scale(1.5)`,
      }}
      className={clsx(className, 'stuffing', {
        'stuffing-white': white,
        'stuffing-purple': purple,
        'stuffing-orange': !white && !purple,
      })}
    >
      {children || text}
    </span>
  );
}
